import React from 'react';
import Markdown from "react-markdown";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';

function ContactUs({ data }) {
    return (
        <div key={data.documentId} className="contact-us light-gray-background">
            <div className="views-row views-row-3 views-row-odd light-gray-background">
                <div className="row contact-div screen-width light-gray-background">
                    <div className="container-fluid no-padding light-gray-background" style={{maxWidth: '1440px'}}>
                        <div className="col-sm-8 hidden-xs light-gray-background contact-panel contact-information"
                             style={{float: 'left'}}>
                            <div className="light-blue-text section-headline">Contact Us</div>
                            <br/>
                            <div className="body-text " style={{lineHeight: '20px'}}>
                                <Markdown>{data.mainText.replaceAll('\n', '  \n')}</Markdown>
                            </div>
                            <div className="body-text " style={{lineHeight: '20px'}}>
                                <Markdown>{data.contactAddress.replaceAll('\n', '  \n')}</Markdown>
                            </div>
                        </div>
                        <div
                            className="col-sm-4 hidden-xs light-blue-background contact-panel white-text forecast-hotlines"
                            style={{float: 'right', paddingTop: '70px'}}>
                            <div className="heading-tag bold hotline-title">air quality forecast hotlines</div>
                            <br/>
                            <div className="body-text " style={{lineHeight: '20px'}}>
                                <Markdown>{data.forecastHotline.replaceAll('\n','  \n')}</Markdown>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ContactUs;
